export default ({ size = 24, fill = "#6B7280" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#F3F4F6" />
    <g>
      <path
        d="M12 12C11.2044 12 10.4413 11.6839 9.87868 11.1213C9.31607 10.5587 9 9.79565 9 9C9 8.20435 9.31607 7.44129 9.87868 6.87868C10.4413 6.31607 11.2044 6 12 6C12.7956 6 13.5587 6.31607 14.1213 6.87868C14.6839 7.44129 15 8.20435 15 9C15 9.79565 14.6839 10.5587 14.1213 11.1213C13.5587 11.6839 12.7956 12 12 12ZM13.0711 13.125C15.3797 13.125 17.25 14.9953 17.25 17.3039C17.25 17.6883 16.9383 18 16.5539 18H7.44609C7.06172 18 6.75 17.6883 6.75 17.3039C6.75 14.9953 8.62031 13.125 10.9289 13.125H13.0711Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_2504_30331">
        <rect width="12" height="12" fill={fill} transform="matrix(-1 0 0 1 18 6)" />
      </clipPath>
    </defs>
  </svg>
);
